import i18n from 'modules/core/lib/i18n'

type AppIds =
  | 'accounting'
  | 'ats'
  | 'ats_careers_page'
  | 'competencies'
  | 'competencies_custom_table'
  | 'competencies_v2'
  | 'complaints'
  | 'document_templates'
  | 'employee_onboarding'
  | 'enps'
  | 'expenses'
  | 'expenses_v2'
  | 'finance'
  | 'goals'
  | 'growth_plans_custom_table'
  | 'payroll_bundle'
  | 'performance_v2'
  | 'shift_management'
  | 'space_control'
  | 'surveys'
  | 'tasks_management'
  | 'time_tracking'
  | 'trainings_custom_table'

type IntegrationIds =
  | 'apple_calendar'
  | 'breezy'
  | 'cobee'
  | 'gmail'
  | 'google_calendar'
  | 'indeed'
  | 'join'
  | 'linkedin'
  | 'outlook'
  | 'outlook_calendar'
  | 'payflow'
  | 'recruitee'
  | 'slack'
  | 'zapier'

type AppIntegrationIds =
  | 'ats_whatsapp'
  | 'desky'
  | 'ats_ideal_disc_integration'
  | 'employee_chat_on_whatsapp'
  | 'linkedin_limited_listings'
  | 'payroll_integrations_a3innuva'
  | 'payroll_integrations_a3nom'
  | 'payroll_integrations_datev'
  | 'payroll_integrations_datev_api'
  | 'payroll_integrations_datev_lauds'
  | 'payroll_integrations_paierh'
  | 'payroll_integrations_silae'
  | 'payroll_integrations_silae_api'
  | 'payroll_integrations_yeap_paierh'
  | 'payroll_integrations_zucchetti'

export type Types = 'app' | 'integration' | 'app_integration'
export type Ids = AppIds | IntegrationIds | AppIntegrationIds

type AppLabels = {
  title: string
  description: string
  uninstall?: string
}

export const getApplicationLabels = (type: Types, id: Ids): AppLabels => {
  switch (`${type}s-${id}`) {
    case 'apps-accounting':
      return {
        title: i18n.t('app_store_v2.apps.accounting.title'),
        description: i18n.t('app_store_v2.apps.accounting.description'),
      }
    case 'apps-ats':
      return {
        title: i18n.t('app_store_v2.apps.ats.title'),
        description: i18n.t('app_store_v2.apps.ats.description'),
      }
    case 'apps-ats_careers_page':
      return {
        title: i18n.t('app_store_v2.apps.ats_careers_page.title'),
        description: i18n.t('app_store_v2.apps.ats_careers_page.description'),
        uninstall: i18n.t('app_store_v2.apps.ats_careers_page.uninstall_modal.description'),
      }
    case 'apps-competencies':
      return {
        title: i18n.t('app_store_v2.apps.competencies.title'),
        description: i18n.t('app_store_v2.apps.competencies.description'),
      }
    case 'apps-competencies_custom_table':
      return {
        title: i18n.t('app_store_v2.apps.competencies_custom_table.title'),
        description: i18n.t('app_store_v2.apps.competencies_custom_table.description'),
      }
    case 'apps-competencies_v2':
      return {
        title: i18n.t('app_store_v2.apps.competencies_v2.title'),
        description: i18n.t('app_store_v2.apps.competencies_v2.description'),
      }
    case 'apps-complaints':
      return {
        title: i18n.t('app_store_v2.apps.complaints.title'),
        description: i18n.t('app_store_v2.apps.complaints.description'),
        uninstall: i18n.t('app_store_v2.apps.complaints.uninstall_copy'),
      }
    case 'apps-document_templates':
      return {
        title: i18n.t('app_store_v2.apps.document_templates.title'),
        description: i18n.t('app_store_v2.apps.document_templates.description'),
      }
    case 'apps-employee_onboarding':
      return {
        title: i18n.t('app_store_v2.apps.employee_onboarding.title'),
        description: i18n.t('app_store_v2.apps.employee_onboarding.description'),
      }
    case 'apps-enps':
      return {
        title: i18n.t('app_store_v2.apps.enps.title'),
        description: i18n.t('app_store_v2.apps.enps.description'),
      }
    case 'apps-expenses':
      return {
        title: i18n.t('app_store_v2.apps.expenses.title'),
        description: i18n.t('app_store_v2.apps.expenses.description'),
        uninstall: i18n.t('app_store_v2.apps.expenses.uninstall_modal.description'),
      }
    case 'apps-expenses_v2':
      return {
        title: i18n.t('app_store_v2.apps.expenses_v2.title'),
        description: i18n.t('app_store_v2.apps.expenses_v2.description'),
        uninstall: i18n.t('app_store_v2.apps.expenses_v2.uninstall_modal.description'),
      }
    case 'apps-finance':
      return {
        title: i18n.t('app_store_v2.apps.finance.title'),
        description: i18n.t('app_store_v2.apps.finance.description'),
        uninstall: i18n.t('app_store_v2.apps.finance.uninstall_modal.description'),
      }
    case 'apps-goals':
      return {
        title: i18n.t('app_store_v2.apps.goals.title'),
        description: i18n.t('app_store_v2.apps.goals.description'),
      }
    case 'apps-growth_plans_custom_table':
      return {
        title: i18n.t('app_store_v2.apps.growth_plans_custom_table.title'),
        description: i18n.t('app_store_v2.apps.growth_plans_custom_table.description'),
      }
    case 'apps-payroll_bundle':
      return {
        title: i18n.t('app_store_v2.apps.payroll_bundle.title'),
        description: i18n.t('app_store_v2.apps.payroll_bundle.description'),
      }
    case 'apps-performance_v2':
      return {
        title: i18n.t('app_store_v2.apps.performance_v2.title'),
        description: i18n.t('app_store_v2.apps.performance_v2.description'),
      }
    case 'apps-shift_management':
      return {
        title: i18n.t('app_store_v2.apps.shift_management.title'),
        description: i18n.t('app_store_v2.apps.shift_management.description'),
      }
    case 'apps-space_control':
      return {
        title: i18n.t('app_store_v2.apps.space_control.title'),
        description: i18n.t('app_store_v2.apps.space_control.description'),
      }
    case 'apps-surveys':
      return {
        title: i18n.t('app_store_v2.apps.surveys.title'),
        description: i18n.t('app_store_v2.apps.surveys.description'),
      }
    case 'apps-tasks_management':
      return {
        title: i18n.t('app_store_v2.apps.tasks_management.title'),
        description: i18n.t('app_store_v2.apps.tasks_management.description'),
        uninstall: i18n.t('app_store_v2.apps.tasks_management.uninstall_modal.description'),
      }
    case 'apps-time_tracking':
      return {
        title: i18n.t('app_store_v2.apps.time_tracking.title'),
        description: i18n.t('app_store_v2.apps.time_tracking.description'),
      }
    case 'apps-trainings_custom_table':
      return {
        title: i18n.t('app_store_v2.apps.trainings_custom_table.title'),
        description: i18n.t('app_store_v2.apps.trainings_custom_table.description'),
      }
    case 'integrations-apple_calendar':
      return {
        title: i18n.t('app_store_v2.integrations.apple_calendar.title'),
        description: i18n.t('app_store_v2.integrations.apple_calendar.description'),
      }
    case 'integrations-breezy':
      return {
        title: i18n.t('app_store_v2.integrations.breezy.title'),
        description: i18n.t('app_store_v2.integrations.breezy.description'),
      }
    case 'integrations-cobee':
      return {
        title: i18n.t('app_store_v2.integrations.cobee.title'),
        description: i18n.t('app_store_v2.integrations.cobee.description'),
      }
    case 'integrations-gmail':
      return {
        title: i18n.t('app_store_v2.integrations.gmail.title'),
        description: i18n.t('app_store_v2.integrations.gmail.description'),
      }
    case 'integrations-google_calendar':
      return {
        title: i18n.t('app_store_v2.integrations.google_calendar.title'),
        description: i18n.t('app_store_v2.integrations.google_calendar.description'),
      }
    case 'integrations-indeed':
      return {
        title: i18n.t('app_store_v2.integrations.indeed.title'),
        description: i18n.t('app_store_v2.integrations.indeed.description'),
      }
    case 'integrations-join':
      return {
        title: i18n.t('app_store_v2.integrations.join.title'),
        description: i18n.t('app_store_v2.integrations.join.description'),
      }
    case 'integrations-linkedin':
      return {
        title: i18n.t('app_store_v2.integrations.linkedin.title'),
        description: i18n.t('app_store_v2.integrations.linkedin.description'),
      }
    case 'integrations-outlook':
      return {
        title: i18n.t('app_store_v2.integrations.outlook.title'),
        description: i18n.t('app_store_v2.integrations.outlook.description'),
      }
    case 'integrations-outlook_calendar':
      return {
        title: i18n.t('app_store_v2.integrations.outlook_calendar.title'),
        description: i18n.t('app_store_v2.integrations.outlook_calendar.description'),
      }
    case 'integrations-payflow':
      return {
        title: i18n.t('app_store_v2.integrations.payflow.title'),
        description: i18n.t('app_store_v2.integrations.payflow.description'),
      }
    case 'integrations-recruitee':
      return {
        title: i18n.t('app_store_v2.integrations.recruitee.title'),
        description: i18n.t('app_store_v2.integrations.recruitee.description'),
      }
    case 'integrations-slack':
      return {
        title: i18n.t('app_store_v2.integrations.slack.title'),
        description: i18n.t('app_store_v2.integrations.slack.description'),
      }
    case 'integrations-zapier':
      return {
        title: i18n.t('app_store_v2.integrations.zapier.title'),
        description: i18n.t('app_store_v2.integrations.zapier.description'),
      }

    case 'app_integrations-ats_whatsapp':
      return {
        title: i18n.t('app_store_v2.app_integrations.ats_whatsapp.title'),
        description: i18n.t('app_store_v2.app_integrations.ats_whatsapp.description'),
      }
    case 'app_integrations-desky':
      return {
        title: i18n.t('app_store_v2.app_integrations.desky.title'),
        description: i18n.t('app_store_v2.app_integrations.desky.description'),
      }
    case 'app_integrations-ats_ideal_disc_integration':
      return {
        title: i18n.t('app_store_v2.app_integrations.dev_ats_ideal_disc_integration.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description'
        ),
      }
    case 'app_integrations-employee_chat_on_whatsapp':
      return {
        title: i18n.t('app_store_v2.app_integrations.employee_chat_on_whatsapp.title'),
        description: i18n.t('app_store_v2.app_integrations.employee_chat_on_whatsapp.description'),
      }
    case 'app_integrations-linkedin_limited_listings':
      return {
        title: i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.title'),
        description: i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.description'),
      }
    case 'app_integrations-payroll_integrations_a3innuva':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_a3innuva.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.description'
        ),
      }
    case 'app_integrations-payroll_integrations_a3nom':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_a3nom.title'),
        description: i18n.t('app_store_v2.app_integrations.payroll_integrations_a3nom.description'),
      }
    case 'app_integrations-payroll_integrations_datev':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_datev.title'),
        description: i18n.t('app_store_v2.app_integrations.payroll_integrations_datev.description'),
      }
    case 'app_integrations-payroll_integrations_datev_api':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_datev_api.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_datev_api.description'
        ),
      }
    case 'app_integrations-payroll_integrations_datev_lauds':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_datev_lauds.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_datev_lauds.description'
        ),
      }
    case 'app_integrations-payroll_integrations_paierh':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_paierh.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_paierh.description'
        ),
      }
    case 'app_integrations-payroll_integrations_silae':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_silae.title'),
        description: i18n.t('app_store_v2.app_integrations.payroll_integrations_silae.description'),
      }
    case 'app_integrations-payroll_integrations_silae_api':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_silae_api.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_silae_api.description'
        ),
      }
    case 'app_integrations-payroll_integrations_yeap_paierh':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_yeap_paierh.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.description'
        ),
      }
    case 'app_integrations-payroll_integrations_zucchetti':
      return {
        title: i18n.t('app_store_v2.app_integrations.payroll_integrations_zucchetti.title'),
        description: i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_zucchetti.description'
        ),
      }
    default:
      throw new Error(`Unknown combination type '${type}' and id '${id}'`)
  }
}
